import { useI18n } from 'vue-i18n'
import type { MessageSchema, AvailableLocales } from '@/locales/schema'

export function useI18nTyped() {
  return useI18n<{ message: MessageSchema }, AvailableLocales>()
}
